<div class="confirmation-body">
  <h2>Submitted Successfully</h2>
  <span [innerHTML]="confirmationVerbiage"></span>

  <br>
  <button mat-flat-button
    class="return-button"
    color="primary"
    (click)="returnHome()">
    Return to Home Page
  </button>
  <ng-container *ngIf="showReturnToQueueButton">
    <button mat-stroked-button
            class="return-button"
            color="primary"
            (click)="returnToQueue()">
      Return to Queue
    </button>
  </ng-container>
</div>